<template>
  <el-dialog
      :visible.sync="dialogVisible"
      :title="title"
      :close-on-click-modal="false"
      :show-close="true"
      width="400px"
      @close="handleClose"
      center
  >
    <el-form
        ref="loginForm"
        :model="loginForm"
        :rules="loginRules"

    >
      <el-form-item label="用户名" prop="username">
        <el-input v-model="loginForm.username" placeholder="请输入用户名"></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="password">
        <el-input
            v-model="loginForm.password"
            type="password"
            placeholder="请输入密码"
        ></el-input>
      </el-form-item>
      <el-form-item class="login-btn-group">
        <el-button
            type="primary"
            class="login-btn"
            :loading="loading"
            @click="handleLogin"
        >
          登录
        </el-button>
<!--        <el-button-->
<!--            type="default"-->
<!--            @click="dialogVisible = false"-->
<!--            style="flex: 0 0 80px;"-->
<!--        >-->
<!--          关闭-->
<!--          </el-button>-->
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { login } from '@/api/user';
import { setToken } from '@/utils/auth';

export default {
  name: 'LoginDialog',
  data() {
    return {
      dialogVisible: false,
      title: '用户登录',
      loginForm: {
        username:'',
        password: ''
      },
      loginRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 3, max: 30, message: '用户名长度在 3 到 30 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能少于 6 个字符', trigger: 'blur' }
        ]
      },
      loading: false
    };
  },
  created() {
    // 监听全局登录事件
    console.log('login component created');
    this.$bus.$on('show-login-dialog', this.showDialog);
    // 检查登录状态
    this.checkLoginStatus();

    // 监听刷新事件
    this.$bus.$on('refresh-current-page', this.refreshData);
  },
  destroyed() {
    this.$bus.$off('show-login-dialog', this.showDialog);
    this.$bus.$off('refresh-current-page', this.refreshData);
  },
  methods: {
    handleClose() {
      this.dialogVisible = false; // 同步关闭状态
    },
    showDialog() {
      console.log("[DEBUG] showDialog . IN");
      this.dialogVisible = true;
    },
    checkLoginStatus() {
      const isLogin = localStorage.getItem('isLogin') === 'true';
      if (!isLogin) {
        // 检查是否有触发标记
        const isToLogin = localStorage.getItem('toLogin') === 'true';
        if (isToLogin) {
          this.showDialog();
        }
      }
    },
    refreshData() {
      // 登录成功后刷新数据
      this.dialogVisible = false;
    },
    async handleLogin() {
      if (!this.$refs.loginForm) return;
      try {
        await this.$refs.loginForm.validate();
        this.loading = true;
        const response = await login(this.loginForm);
        const access_token = response.access_token;

        // 存储认证状态
        setToken(access_token);
        localStorage.setItem('isLogin', 'true');
        localStorage.removeItem('toLogin');

        this.$message.success('登录成功');

        // 触发登录状态变化事件
        this.$bus.$emit('login-status-changed', true);
        // 触发页面刷新事件
        this.$bus.$emit('refresh-current-page');

      } catch (error) {
        this.$message.error(error.message || '登录失败');
      } finally {
        this.loading = false;
        this.handleClose();
      }
    }
  }
};
</script>

<style scoped>
.login-btn-group {
  margin-top: 20px;
}
.login-btn {
  width: 100%;
}

/* login/index.vue 样式部分 */
.el-dialog {
  margin: 0 auto !important; /* 强制水平居中 */
  width: 90% !important; /* 响应式宽度，避免过宽 */
  max-width: 500px; /* 最大宽度限制 */
}

.el-dialog__body {
  padding: 20px !important; /* 统一内边距 */
}

/* 确保表单项左右边距一致 */
.el-form-item {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

/* 输入框宽度100%，避免左侧留白 */
.el-input__inner {
  width: 100% !important;
}

/* 重置弹窗默认样式 */
.login-dialog .el-dialog__header {
  padding: 20px 20px 10px !important;
}

.login-dialog .el-dialog__footer {
  padding: 10px 20px 20px !important;
}

</style>